(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glove-filter-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glove-filter-bar')) {
    const SIZE_PARAM = 'filter.v.option.size';
    const DENSITY_KEY = 'gfb-grid-cols';

    class GloveFilterBar extends HTMLElement {
      connectedCallback() {
        this.url = new URL(window.location.href);
        try {
          this.sizeMap = JSON.parse(this.querySelector('[data-size-map]').textContent);
        } catch (e) {
          this.sizeMap = {};
        }
        this.activeSizes = this.url.searchParams.getAll(SIZE_PARAM);

        this.initSizes();
        this.initLinks();
        this.initDropdowns();
        this.initSort();
        this.initDensity();
        this.applySizeFilter();

        this.observer = new MutationObserver(() => {
          this.applySizeFilter();
          this.applyDensity();
        });
        const container = document.querySelector('results-list') || document.body;
        this.observer.observe(container, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      /** Navigate keeping the current query, minus pagination. */
      go(url) {
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }

      initSizes() {
        const all = this.querySelector('[data-size-all]');
        if (all) {
          const active = !this.activeSizes.length;
          all.classList.toggle('is-active', active);
          all.setAttribute('aria-pressed', String(active));
          const url = new URL(this.url);
          url.searchParams.delete('page');
          url.searchParams.delete(SIZE_PARAM);
          all.href = url.toString();
        }
        this.querySelectorAll('[data-size]').forEach((el) => {
          const size = el.dataset.size;
          const active = this.activeSizes.includes(size);
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-pressed', String(active));
          const url = new URL(this.url);
          url.searchParams.delete('page');
          url.searchParams.delete(SIZE_PARAM);
          if (!active) url.searchParams.append(SIZE_PARAM, size);
          el.href = url.toString();
        });
      }

      initLinks() {
        const tags = (this.dataset.activeTags || '').split(',').filter(Boolean);
        this.querySelectorAll('[data-tag-group]').forEach((el) => {
          el.addEventListener('click', (event) => {
            event.preventDefault();
            const group = el.dataset.tagGroup;
            const groupTags = [...this.querySelectorAll(`[data-tag-group="${group}"]`)]
              .map((o) => o.dataset.tag)
              .filter(Boolean);
            const next = tags.filter((t) => !groupTags.includes(t));
            if (el.dataset.tag && !el.classList.contains('is-active')) next.push(el.dataset.tag);
            const url = new URL(this.url);
            url.pathname = this.dataset.collectionUrl + (next.length ? '/' + next.join('+') : '');
            this.go(url);
          });
        });
      }

      initDropdowns() {
        const dds = [...this.querySelectorAll('[data-dd]')];
        dds.forEach((dd) => {
          dd.addEventListener('toggle', () => {
            if (!dd.open) return;
            dds.forEach((other) => other !== dd && (other.open = false));
            dd.classList.remove('is-right');
            const panel = dd.querySelector('.gfb__panel');
            if (panel && panel.getBoundingClientRect().right > document.documentElement.clientWidth - 8) {
              dd.classList.add('is-right');
            }
          });
        });
        document.addEventListener('click', (event) => {
          dds.forEach((dd) => dd.open && !dd.contains(event.target) && (dd.open = false));
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') dds.forEach((dd) => (dd.open = false));
        });
      }

      initSort() {
        this.querySelectorAll('[data-sort]').forEach((el) => {
          el.addEventListener('click', (event) => {
            event.preventDefault();
            const url = new URL(this.url);
            url.searchParams.set('sort_by', el.dataset.sort);
            this.go(url);
          });
        });
      }

      initDensity() {
        let cols = '3';
        try {
          cols = sessionStorage.getItem(DENSITY_KEY) || '3';
        } catch (e) {}
        this.cols = cols;
        this.querySelectorAll('[data-cols]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.cols = btn.dataset.cols;
            try {
              sessionStorage.setItem(DENSITY_KEY, this.cols);
            } catch (e) {}
            this.applyDensity();
          });
        });
        this.applyDensity();
      }

      applyDensity() {
        this.querySelectorAll('[data-cols]').forEach((btn) =>
          btn.setAttribute('aria-pressed', String(btn.dataset.cols === this.cols))
        );
        document.querySelectorAll('.product-grid').forEach((grid) => {
          const value = `repeat(${this.cols}, 1fr)`;
          if (grid.style.getPropertyValue('--product-grid-columns-desktop') !== value) {
            grid.style.setProperty('--product-grid-columns-desktop', value, 'important');
          }
        });
      }

      applySizeFilter() {
        // sizeMap only holds in-stock products in the current result set (sold-out cards are
        // hidden by product-card.liquid), so it is the source of truth for the count.
        const sizing = this.activeSizes.length > 0;
        const matches = (sizes) => !sizing || sizes.some((s) => this.activeSizes.includes(s));
        document.querySelectorAll('.product-grid > .product-grid__item[data-product-id]').forEach((card) => {
          const sizes = this.sizeMap[card.dataset.productId];
          card.classList.toggle('gfb-hidden', sizing && !(sizes && matches(sizes)));
        });
        const visible = Object.values(this.sizeMap).filter(matches).length;
        const count = this.querySelector('[data-count]');
        if (count && count.textContent !== String(visible)) {
          count.textContent = visible;
          this.querySelector('[data-count-label]').textContent = visible === 1 ? 'product' : 'products';
        }
        const empty = this.querySelector('[data-empty]');
        if (empty) empty.hidden = visible > 0;
      }
    }

    customElements.define('glove-filter-bar', GloveFilterBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
